import { uuid } from '../ids.js';
import { applyLocal, applyLocalMany, writeTx } from '../mutate.js';
import { getDeviceId } from '../meta.js';
import { recomputeCards } from '../../scheduler/recompute.js';
import { studyDayEnd } from '../../scheduler/day.js';

export const FLAGS = [
  { value: 0, label: 'No flag', color: 'transparent' },
  { value: 1, label: 'Red', color: '#d9472b' },
  { value: 2, label: 'Orange', color: '#e08a1e' },
  { value: 3, label: 'Green', color: '#2e7d4f' },
  { value: 4, label: 'Blue', color: '#2f6fb3' },
  { value: 5, label: 'Purple', color: '#7a4fb3' },
];

export function setFlag(db, ids, flag) {
  return applyLocalMany(db, ids.map((id) => ({ kind: 'card', id, patch: { flag } })));
}

export function setSuspended(db, ids, suspended) {
  return applyLocalMany(db, ids.map((id) => ({ kind: 'card', id, patch: { suspended } })));
}

/** Hide until the next study day. */
export function bury(db, ids, now = Date.now()) {
  const until = studyDayEnd(now);
  return applyLocalMany(db, ids.map((id) => ({ kind: 'card', id, patch: { buriedUntil: until } })));
}

export function unbury(db, ids) {
  return applyLocalMany(db, ids.map((id) => ({ kind: 'card', id, patch: { buriedUntil: null } })));
}

/** Reset cards to new. Recorded as a log entry so it replays identically everywhere. */
export async function forgetCards(db, ids) {
  const deviceId = await getDeviceId(db);
  const now = Date.now();
  await writeTx(db, async () => {
    for (const cardId of ids) {
      await applyLocal(db, 'reviewLog', uuid(), {
        cardId,
        rating: 0,
        kind: 'reset',
        reviewedAt: now,
        durationMs: 0,
        deviceId,
        deletedAt: null,
      });
    }
  });
  await recomputeCards(db, ids);
}
